import { Box } from '@mui/material';
import { Add as AddIcon } from '@mui/icons-material';
import {
  FormTitleBox,
  LoadingSkeleton,
  ConfirmationDialog,
  TableBodySkeleton,
} from '../../common/components';
import BankAccountsDataTable from './components/BankAccountsDataTable';
import BankAccountsPagination from './components/BankAccountsPagination';
import BankAccountDialog from './components/BankAccountDialog';
import { useBankAccountsTable } from './hooks/useBankAccountsTable';
import { formatBankName } from './utils/formatters';

const BankAccounts = () => {
  const {
    data,
    isLoading,
    totalPages,
    totalCount,
    page,
    rowsPerPage,
    searchTerm,
    dialogOpen,
    editMode,
    selectedBankAccount,
    deleteDialogOpen,
    accountToDelete,
    mutationsLoading,
    handleSearch,
    handlePageChange,
    handleRowsPerPageChange,
    handleOpenDialog,
    handleCloseDialog,
    handleEdit,
    handleCreate,
    handleUpdate,
    handleDeleteRequest,
    handleConfirmDelete,
    handleCancelDelete,
  } = useBankAccountsTable();

  return (
    <Box>
      <FormTitleBox
        title="Bancos | Cuentas bancarias"
        showButton
        buttonText="Nueva cuenta"
        buttonIcon={AddIcon}
        onButtonClick={handleOpenDialog}
        showSearch
        searchLabel="Buscar cuenta bancaria"
        searchValue={searchTerm}
        onSearchChange={handleSearch}
        searchSize="medium"
      />

      <BankAccountsDataTable
        data={data}
        isLoading={isLoading}
        onEdit={handleEdit}
        onDelete={handleDeleteRequest}
        LoadingComponent={TableBodySkeleton}
      />

      {totalPages > 1 && (
        <BankAccountsPagination
          totalPages={totalPages}
          totalCount={totalCount}
          page={page}
          onPageChange={handlePageChange}
          rowsPerPage={rowsPerPage}
          onRowsPerPageChange={handleRowsPerPageChange}
        />
      )}

      <BankAccountDialog
        open={dialogOpen}
        onClose={handleCloseDialog}
        editMode={editMode}
        selectedBankAccount={selectedBankAccount}
        onCreate={handleCreate}
        onUpdate={handleUpdate}
        isSubmitting={mutationsLoading}
      />

      <ConfirmationDialog
        open={deleteDialogOpen}
        onClose={handleCancelDelete}
        onConfirm={handleConfirmDelete}
        entityName="cuenta bancaria"
        message={
          accountToDelete
            ? `¿Confirmás eliminar la cuenta "${formatBankName(accountToDelete.bank_name)} - ${accountToDelete.account_number}"?`
            : '¿Confirmás eliminar la cuenta bancaria seleccionada?'
        }
      />
    </Box>
  );
};

export default BankAccounts;
